import * as React from 'react'

import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { getParams } from '../../../commons/utils'
import {
  CHANGE_NEW_PASSWORD_CHECK_FORM,
  CHANGE_NEW_PASSWORD_FORM,
  POST_RESET_PASSWORD
} from '../../actions/authActions'
import Button from '../../components/atoms/Button/Button'
import ImageAsset, { ImageAssetType } from '../../components/atoms/ImageAsset/ImageAsset'
import Logo, { LogoType } from '../../components/atoms/Logo/Logo'
import LimitTextField from '../../components/molecules/LimitTextField/LimitTextField'
import CommonFooter from '../../components/organisms/CommonFooter/CommonFooter'
import { CustomPcStore } from '../../store'
import * as styles from './PasswordResetPage.css'

interface PasswordResetPageProps {
  newPassword: string
  newPasswordForCheck: string
  handleChangeForm: (params: any) => void
  handleChangeCheckForm: (params: any) => void
  postResetPassword: any
  isLoading: any
  resetPasswordStatus: boolean
  inputFormErrors: any
}

class PasswordResetPage extends React.PureComponent<PasswordResetPageProps> {
  public render() {
    const {
      newPassword,
      newPasswordForCheck,
      handleChangeForm,
      handleChangeCheckForm,
      postResetPassword,
      isLoading,
      resetPasswordStatus,
      inputFormErrors
    } = this.props

    return (
      <div className={styles.background}>
        <div className={styles.container}>
          <div className={styles.backgroudImage}>
            <ImageAsset type={ImageAssetType.TOP_VISUAL} />
          </div>
          <div className={styles.mainContent}>
            <div className={styles.titlePart}>
              <div className={styles.logo}>
                <Logo type={LogoType.GRAY} />
              </div>
              <h1 className={styles.title}>パスワードの再設定</h1>
              <p className={styles.text}>新しく設定したいパスワードを入力してください。</p>
            </div>
            <div className={styles.passwordFormContainer}>
              <LimitTextField
                title="新しいパスワード"
                showLimitCount={false}
                placeholder={'半角英数字8文字以上'}
                text={newPassword}
                type="password"
                handleChange={(e: any) => handleChangeForm({ newPassword: e.targetTitle })}
                errorMessage={inputFormErrors.password}
              />
            </div>
            <div className={styles.passwordFormContainer}>
              <LimitTextField
                title="新しいパスワードを再入力"
                showLimitCount={false}
                placeholder={'半角英数字8文字以上'}
                text={newPasswordForCheck}
                type="password"
                handleChange={(e: any) => handleChangeCheckForm({ newPasswordForCheck: e.targetTitle })}
              />
              <div className={styles.button}>
                {inputFormErrors.password || newPasswordForCheck === '' ? null : newPasswordForCheck === newPassword ? (
                  <Button handleClick={() => postResetPassword(getParams().token)} isLoading={isLoading}>
                    変更内容を保存する
                  </Button>
                ) : (
                  <p>同じパスワードを入力してください。</p>
                )}
              </div>
              <div className={styles.resetStatus}>
                {resetPasswordStatus === null ? null : resetPasswordStatus ? (
                  <p>パスワードリセットが成功しました</p>
                ) : (
                  <p>パスワードリセットに失敗しました</p>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    )
  }
}

const mapStateToProps = (state: CustomPcStore) => ({
  newPassword: state.auth.newPassword,
  newPasswordForCheck: state.auth.newPasswordForCheck,
  isLoading: state.auth.isResetPasswordLoading,
  resetPasswordStatus: state.auth.resetPasswordStatus,
  inputFormErrors: state.auth.resetPasswordInputFormErrors
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleChangeForm: (newPassword: string) => dispatch(CHANGE_NEW_PASSWORD_FORM(newPassword)),
  handleChangeCheckForm: (newPasswordForCheck: string) => dispatch(CHANGE_NEW_PASSWORD_CHECK_FORM(newPasswordForCheck)),
  postResetPassword: (token: string) => dispatch(POST_RESET_PASSWORD(token))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordResetPage)
